import React, {PropTypes} from 'react';
import {Table, TableHeader, TableRow, TableCell} from 'pui-react-table';
import { Grid, Row, Col, Button, PageHeader } from 'react-bootstrap';
import {
  Link
} from 'react-router-dom'
// LOCAL
import ClientActionsCell from './ClientActionsCell'
// SHARED
import LoadIndicator from '../core/components/LoadIndicator'
import styled from 'styled-components'

const AdStyle = styled.div`
  border: solid lightgrey 1px;
  border-radius: 4px;
  margin: 25px;
  padding: 10px;
`
const PremiumPromoAd = ({count}) =>{
  if (count==0) return null
  if (count<5) return (
    <AdStyle>
      <h4>
        You have <b>{(5-count)}</b> invites left to go to get Premium free.
        Plus, get $10 for everyone who subscribes.
      </h4>
    </AdStyle>
  )
  if (count>=5) return (
    <AdStyle>
      <h3>
        You Get Everlance Premium for Free - Congrats!
      </h3>
      <h4>
        Thanks for inviting 5 or more clients!
        To get your free Premium subcription, simply email <a href="mailto:jake@everlance.com">jake@everlance.com</a> with your website or LinkedIn profile (or other proof of being a tax pro).
      </h4>
    </AdStyle>
  )
}

export default class ClientsTab extends React.Component {
  changeTabsToProfile(){
    this.props.changeTabsToTab("2")
  }

  render() {
    const {user, clients} = this.props

    const columns = [
      {
        attribute: 'name',
        displayName: 'Name',
        sortable: false
      },
      {
        attribute: 'last',
        displayName: 'Last',
        sortable: false
      },
      {
        attribute: 'email',
        displayName: 'Email',
        sortable: false
      },
      {
        attribute: 'token_id',
        displayName: 'Actions',
        sortable: false,
        CustomCell: ClientActionsCell
      }
    ];

    const accountantGroup = user.group_as_accountant || {}

    return (<div className="tab-content clients-tab">
      {!accountantGroup && (
          <LoadIndicator />
      )}
    {accountantGroup && !accountantGroup.first_name && (
      <Grid fluid={true}>
        <Row className="show-grid">
          <Col xs={12} sm={12} md={12}>
          <div className="clients-tab-empty-state">
            <h3>Did you know Qualified Tax Pros get Everlance Premium for Free?</h3>
            <h4>Plus, get $10 for every client who subscribes and give them 20% off Premium.</h4>
            <Button onClick={this.changeTabsToProfile.bind(this)}  className="add-first-client-button btn-main-green">
              Complete Profile
            </Button>
          </div>
          </Col>
        </Row>
        <PageHeader></PageHeader>
        <hr/>

      </Grid>
    )}

      <Grid fluid={true}>
{clients && <PremiumPromoAd count={clients.length}/>}
        {clients && (
          <Row className="show-grid">
            <Col xs={8} sm={8} md={8}>
                <h4 className="column-title">Client List</h4>
            </Col>
            <Col xs={4} sm={4} md={4}>
                  <Button href="/accountants/clients/new" className="add-client-button btn-main-green">
                  Add Client
                  </Button>
            </Col>
          </Row>
        )}

        <Row className="show-grid">
          <Col xs={12} sm={12} md={12}>
            { clients && <Table columns={columns} data={clients} /> }
            { !clients && accountantGroup.first_name &&
              <div className="clients-tab-empty-state">
                <h3>Get Everlance Premium for Free,  plus Referral Bonuses</h3>
                <h4>Simply invite 5 or more clients.</h4>
                <h4>Get $10 for every client who subscribes and give them 20% off premium.</h4>

                <Link to={"/accountants/clients/new"}>
                  <Button className="add-first-client-button btn-main-green">
                    Invite Clients now
                  </Button>
                </Link>

              </div>
            }
          </Col>
        </Row>

        {clients && (
          <Row className="show-grid">
            <Col xs={8} sm={8} md={8}>
              <p>{(clients.length + " results" )}</p>
            </Col>
          </Row>
        )}
      </Grid>

    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/accountants/ClientsTab.js